function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#0288D1",
  d: "M21.6 18.6c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V3c0-1.657 1.343-3 3-3h15.6c1.657 0 3 1.343 3 3v15.6z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M3.6 7.8h3V18h-3V7.8zm1.491-1.2h-.017C4.18 6.6 3.6 5.933 3.6 5.1c0-.852.597-1.5 1.508-1.5.913 0 1.475.648 1.492 1.5 0 .832-.579 1.5-1.509 1.5zM18 18h-3v-5.46c0-1.318-.735-2.218-1.915-2.218-.9 0-1.388.607-1.624 1.194-.087.21-.061.79-.061 1.084V18h-3V7.8h3v1.57c.433-.67 1.11-1.57 2.843-1.57 2.147 0 3.756 1.35 3.756 4.364L18 18z"
}));

var SvgIconLinkedin = function SvgIconLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-linkedin.b34eb9f4.svg";
export { ForwardRef as ReactComponent };